import { GetterTree } from 'vuex';
import { AssertionModel, AssertionInfo } from '@descomplica/dex-models';
import { AssertionState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<AssertionState, RootState> = {
  assertionById: (state, assertionsGetters) => (assertionId: number) => {
    const assertion = state.assertions[assertionId.toString()];

    return assertion ? new AssertionModel(assertion, assertionsGetters) : undefined;
  },
  assertionsByQuestionId: (state, assertionsGetters) => (questionId: number) => {
    return Object.values(state.assertions)
      .filter((assertion) => assertion.questionId === questionId)
      .map((assertion: AssertionInfo) => new AssertionModel(assertion, assertionsGetters));
  },
};

export default getters;
